import { useCallback, useRef } from 'react';
import { ITicker, IWatchedTicker, enums } from '@kattana-io/common';
import useTicker from '../../../hooks/useTicker';
import Text from '../../../atoms/Text';
import PairIcons from '../../../molecules/PairIcons';
import { decorateExchangeName } from '../../../helpers/decorators';

interface IWatchlistTickerMobileProps {
  ticker: ITicker | IWatchedTicker;
  active: boolean;
  actionRemoveWatchlist?: (id: number) => void;
  actionAddWatchlist?: (item: ITicker) => void;
}

const WatchlistTickerMobile = ({
  ticker,
  // active,
  actionRemoveWatchlist,
  actionAddWatchlist,
}: IWatchlistTickerMobileProps) => {
  const item = useTicker(ticker);
  const ref = useRef(null);

  const onUnfav = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      if (ref.current) {
        (ref.current as HTMLElement).classList.add('watchlist__row--remove');
        setTimeout(() => {
          if (actionRemoveWatchlist) {
            actionRemoveWatchlist(ticker.id);
          }
        }, 150);
      }
    },
    [actionRemoveWatchlist, ticker.id]
  );

  const onFav = useCallback(
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      if (actionAddWatchlist) {
        actionAddWatchlist(ticker);
      }
    },
    [actionAddWatchlist, ticker]
  );

  return (
    <div ref={ref} className='ticker__cell'>
      {actionRemoveWatchlist && (
        <div
          className={`star star--${
            'tag' in ticker && ticker.tag ? ticker.tag : enums.Tag.Blue
          } icon-star-active`}
          onClick={onUnfav}
        />
      )}
      {actionAddWatchlist && (
        <div
          className='star tickers_footer_mobile__star--normal icon-star'
          data-qa='addFavourite'
          onClick={onFav}
        />
      )}
      <PairIcons
        chain={item.chain}
        pair={item.name}
        base_address={item.base_address}
        quote_address={item.quote_address}
        base_slug={item.base_slug}
        quote_slug={item.quote_slug}
      />
      <div className='name_exchange'>
        <Text size={14} className='text--weight-500 text--grey-400'>
          {item.name}
        </Text>
        <Text size={12} className='text--weight-500 text--grey-600'>
          {decorateExchangeName(item.exchange, item.chain)}
        </Text>
      </div>
    </div>
  );
};

export default WatchlistTickerMobile;
